import { Record } from 'immutable';
import * as A from './actions';
import type { PaySettingsStateData } from './types';
import { paymentProvidersList, payApproversList } from './helpers';

const initialState = Record<PaySettingsStateData>({
  isProvidersLoaded: false,
  providers: paymentProvidersList(),
  approvers: payApproversList(),
});

export const reducer = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  paySettings(state = initialState(), action: any) {
    switch (action.type) {
      case A.getProvidersAction.request:
        return state.set('isProvidersLoaded', false);

      case A.getProvidersAction.success:
        return state.set('providers', action.payload).set('isProvidersLoaded', true);

      case A.connectProviderAction.success:
      case A.disconnectProviderAction.success:
      case A.changeStatusForProviderAction.success:
        return state.updateIn(['providers'], (providers: any) =>
          providers.set(
            providers.findIndex((provider: any) => provider.providerName === action.payload.providerName),
            action.payload,
          ),
        );

      case A.getProviderApproversAction.success:
        return state.set('approvers', action.payload);

      default:
        return state;
    }
  },
};
